<template>
  <div>
    <geofence-list-filters :categories-filter.sync="gCategoriesFilter" :type-filter.sync="gTypeFilter"
                           :contracts-filter.sync="gContractsFilter" :owners-filter.sync="gOwnersFilter" :group-filter.sync="gGroupFilter"
                           :category-options="gCategoriesOptions" :contract-options="gContractsOptions" :group-options="gGroupsOptions"
                           :devices-options="gDevicesOptions" :device-filter.sync="gDeviceFilter" :owners-options="gOwnersOptions"
                           :type-options="gTypesOptions">
    </geofence-list-filters>

    <t-b-per-page :per-page.sync="gPerPage"
                  :search-query.sync="gSearchQuery"
                  :per-page-options="perPageOptions">
    </t-b-per-page>

    <b-table ref="refListTable" class="table-responsive"
             selectable select-mode="single" @row-selected="rowSelected"
             :items="geofences" responsive :fields="tableColumns" primary-key="id"
             show-empty :empty-text="$t('No matching records found')">
      <template #cell(id)="data">
        {{ ++data.index }}
      </template>
    </b-table>

    <t-b-pagination :page.sync="gCurrentPage"
                    :per-page="gPerPage"
                    :total-rows="total">
    </t-b-pagination>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import MapTable from '@/views/modules/maps/sidesbar/MapTable'
import GeofenceListFilters from '@/views/modules/geofence/geofence-list/GeofenceListFilters'
import store from '@/store'
import { computed, ref, watch } from '@vue/composition-api'
import useGeofenceFilter from '@/views/modules/geofence/useGeofenceFilter'
import TBPagination from '@/components/sidebar/TBPagination'
import TBPerPage from '@/components/sidebar/TBPerPage'


export default {
  components: { BTable, MapTable, GeofenceListFilters, TBPagination , TBPerPage},
  setup() {

    const filter = ref({})

    const gPerPage = ref(10)
    const gCurrentPage = ref(1)
    const gSearchQuery = ref('')

    const total = ref(0)

    const tableColumns = ['id', 'name','contract', 'category']
    const perPageOptions = [5,10,50,100,200,500]

    const geofences = computed(() => store.state.h_map_store.geofences)

    const { gOwnersFilter, gOwnersOptions, gTypeFilter, gTypesOptions,
      gCategoriesOptions, gCategoriesFilter, gContractsFilter, gContractsOptions,
      gGroupFilter, gGroupsOptions, gDevicesOptions, gDeviceFilter } = useGeofenceFilter()

    watch([gPerPage, gCurrentPage, gSearchQuery, gTypeFilter,
      gDeviceFilter, gGroupFilter, gCategoriesFilter, gContractsFilter, gOwnersFilter], () => {

      filter.value = {
        ...(gGroupFilter.value && {group: gGroupFilter.value}),
        ...(gCategoriesFilter.value && {categories: gCategoriesFilter.value}),
        ...(gContractsFilter.value && {contracts: gContractsFilter.value}),
        ...(gOwnersFilter.value && {owners: gOwnersFilter.value}),
        ...(gDeviceFilter.value && {device: gDeviceFilter.value}),
        ...(gTypeFilter.value && {type: gTypeFilter.value}),
        ...(gSearchQuery.value && {q: gSearchQuery.value})
      }

      fetch()
    })

    const fetch = () => {
      store.dispatch('h_map_store/getAllGeofences', {
        q: gSearchQuery.value,
        length: gPerPage.value,
        page: gCurrentPage.value,
        ...filter.value
      }).then(res => {
        total.value = res.data.meta.total
      })
    }

    fetch()

    const rowSelected = () => {

    }

    return {
      perPageOptions,
      gOwnersFilter, gOwnersOptions, gTypeFilter, gTypesOptions,
      gCategoriesOptions, gCategoriesFilter, gContractsFilter, gContractsOptions,
      gGroupFilter, gGroupsOptions, gDevicesOptions,gDeviceFilter,

      gCurrentPage,gPerPage,total,
      gSearchQuery,

      tableColumns,
      geofences,

      rowSelected
    }
  }

}
</script>

<style scoped>

</style>
